import { useAppSelector } from '@shared/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyRequisite = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyRequisite);
};
